import styled from 'styled-components';

export const GoodsCategory = styled.div``;

export const SmallContainer = styled.div`
  width: 161px;
  position: absolute;
  bottom: 0;

  > .bg {
    position: absolute;
    left: -36px;
    right: -28px;
    top: -31px;
    bottom: -7px;
    z-index: -10;

    background-image: url(${require('../img/small-container-bg.png')});
    background-size: 100% auto;
  }
`;

export const BigContainer = styled.div`
  position: absolute;
  width: 161px;
  height: 483px;
  bottom: 46px;
  transform: translateY(100%);
  z-index: 1;
  background: rgba(0, 0, 0, 0.85);

  > .bg-img-wrapper {
    position: absolute;
    z-index: -1000;
    top: -34px;
    bottom: -37px;
    left: -35px;
    right: -35px;

    > .bg-img {
      width: 100%;
      height: 100%;
    }
  }
`;

export const ChildPanel = styled.div`
  width: 845px;
  height: 441px;

  position: absolute;
  /* right: -6px; */
  right: 0;
  top: 46px;
  transform: translateX(100%);

  /* visibility: hidden;

  &.show {
    visibility: visible;
  } */
`;

export const CategoryContainer = styled.div``;

export const CategoryItem = styled.div`
  height: 46px;
  line-height: 46px;
  box-sizing: border-box;
  padding-left: 42px;

  font-size: 14px;
  font-weight: 400;
  font-family: PingFangSC;
  color: rgba(255, 255, 255, 1);
  position: relative;
  z-index: 1;

  &:not(:first-child) {
    border-top: 1px dashed rgba(255, 255, 255, 0.2);
  }

  > .icon {
    display: block;
    position: absolute;
    width: 10px;
    height: 13px;
    opacity: 0.8;
    left: 20px;
    top: 0;
    bottom: 0;
    margin: auto;
  }

  &.all {
    font-size: 15px;
    font-weight: 500;
    > .icon {
      position: absolute;
      width: 16px;
      height: 16px;
      left: 16px;
      top: 0;
      bottom: 0;
      margin: auto;
    }
  }

  > .more {
    position: absolute;
    width: 4px;
    height: 7px;
    opacity: 0.5;
    right: 19px;
    top: 0;
    bottom: 0;
    margin: auto;
  }
`;

export const CategoryItemHover = styled.div`
  height: 46px;
  line-height: 46px;
  box-sizing: border-box;
  padding-left: 49px;

  position: relative;
  z-index: 100;

  font-size: 14px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(24, 246, 254, 1);

  > .icon {
    display: block;
    position: absolute;
    width: 10px;
    height: 13px;
    opacity: 0.8;
    left: 20px;
    top: 0;
    bottom: 0;
    margin: auto;
  }

  > .bg-img-wrapper {
    position: absolute;
    z-index: -1000;
    top: 0;
    bottom: 0;
    left: 0;
    right: -10px;
    > .bg-img {
      position: absolute;

      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }
  }
`;

export const CategoryItemWrapper = styled.div`
  cursor: pointer;
  /* ${CategoryItemHover} {
    display: none;
  } */
  /* &:hover {
    ${CategoryItemHover} {
      display: block;
    }
    ${CategoryItem} {
      display: none;
    }
  } */
`;
